import type { ClientParty } from '@game/shared-types';

export interface PartyState {
  party?: ClientParty;
  isPartyLeader: boolean;
  isPartyMember: boolean;
  isPartyInvitee: boolean;
}

export const partyDefault: PartyState = {
  isPartyLeader: false,
  isPartyMember: false,
  isPartyInvitee: false,
};
